import { t } from "@lingui/core/macro";

import { Button } from "@whoosh/design-system/src/components/controls";
import {
  ArrowLeftIcon,
  CloseIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

type DiningAttendeesModalHeaderProps = {
  modeType: "list" | "add" | "replace";
  addModeTitle: string;
  onClose: () => void;
  onBack: () => void;
};

export const DiningAttendeesModalHeader = ({
  modeType,
  addModeTitle,
  onClose,
  onBack,
}: DiningAttendeesModalHeaderProps) => {
  const isListMode = modeType === "list";

  return (
    <HStack
      alignItems="center"
      flexGrow={1}
      justifyContent="space-between"
      paddingBottom={5}
    >
      <Button
        variant="secondary"
        size="small"
        leftIcon={isListMode ? <CloseIcon /> : <ArrowLeftIcon />}
        onPress={isListMode ? onClose : onBack}
        accessibilityLabel={isListMode ? t`Close` : t`Go back`}
      />
      <Text variant="mainBaseSemiBold" flex={1} textAlign="center">
        {isListMode ? t`Edit Reservation` : addModeTitle}
      </Text>
      <Box width={8} />
    </HStack>
  );
};
